import { ProtocolContentData } from "../../protocol";
export default class SafetyAndSecurityRoundInPort extends ProtocolContentData {
    portName;
    freeText;
    marSecLevel;
    constructor(portName, freeText, marSecLevel) {
        super();
        this.portName = portName;
        this.freeText = freeText;
        this.marSecLevel = marSecLevel;
    }
}
//# sourceMappingURL=SafetyAndSecurityRoundInPort.js.map